import React, { useContext } from "react";
import { getCloudinaryUrl, isEmpty } from "@swiggy-private/js-utils";

import { ResponseContext, ScreenNames } from "@swiggy-private/portal-dineout-context";
import { IApiConfigs } from "@swiggy-private/portal-dineout-context";
import Track from "./Track";
import type { ITrackProps } from "./types";
import { useTrackPolling } from "./useTrackPolling";
import { ErrorPageWrapper } from "../BillSummary/styles";
import { EMPTY_TRACK_SCREEN } from "../constants/track";
import { ErrorComponent } from "../ErrorComponent";
import { useAnalytics } from "../hooks";
import { TabContentLoadingSkeleton } from "../Skeleton";

const TrackPage = ({
    headers,
    apiHost,
    sdk,
    clickAnalytics: defaultClickAnalytics,
    impressionAnalytics: defaultImpressionAnalytics,
    getCardDataByType,
    handleErrorCtaClick,
    genericOnclick,
    forceFetch,
    onInvalidWidget,
    onWidgetError,
    onEmptyPage,
    screenName,
}: ITrackProps) => {
    const { state } = useContext(ResponseContext);

    const { impressionAnalytics, clickAnalytics } = useAnalytics({
        screenName: ScreenNames.TRACK,
        defaultImpressionAnalytics,
        defaultClickAnalytics,
    });

    const { showEmptyOrderError, allCards } = useTrackPolling({
        apiHost,
        headers,
        getCardDataByType,
        forceFetch,
    });

    if (showEmptyOrderError) {
        return (
            <ErrorPageWrapper>
                <ErrorComponent
                    {...EMPTY_TRACK_SCREEN}
                    onCtaClick={handleErrorCtaClick}
                    imgSrc={getCloudinaryUrl(EMPTY_TRACK_SCREEN.img, {
                        width: 220 * 2,
                        height: 200 * 2,
                    })}
                    showFullPage={false}
                />
            </ErrorPageWrapper>
        );
    }

    if (isEmpty(state.track?.data?.success?.cards)) {
        return <TabContentLoadingSkeleton />;
    }

    if (state.track.loading) {
        return <TabContentLoadingSkeleton />;
    }

    const popupConfigsFromState = state.track?.data?.success?.configs as IApiConfigs;

    return (
        <Track
            cards={allCards}
            popupConfigs={popupConfigsFromState}
            sdk={sdk}
            headers={headers}
            clickAnalytics={clickAnalytics}
            impressionAnalytics={impressionAnalytics}
            genericOnclick={genericOnclick}
            onEmptyPage={onEmptyPage}
            onInvalidWidget={onInvalidWidget}
            onWidgetError={onWidgetError}
            screenName={screenName}
        />
    );
};

export default TrackPage;
